<template>
  <el-dialog
      width="1080px"
      :visible.sync="visible"
      title="运费模板"
  >
    <el-form size="small" ref="form" :model="form" label-position="right" label-width="80px">

      <el-form-item label="规则名称" prop="name">
        <el-input  v-model="form.name" autoComplete="off" clearable  placeholder="请输入规则名称"></el-input>
      </el-form-item>
      <el-form-item label="默认规则" prop="is_default">
        <el-radio-group v-model="form.is_default">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发货运费">
        <div>
          <el-row>
            <el-col :span="8" class="p-2">
              <el-input placeholder="" v-model="form.weight" style="">
                <template slot="prepend">首重</template>
                <template slot="append">kg</template>
              </el-input>
            </el-col>
            <el-col :span="8" class="p-2">
              <el-input placeholder="" v-model="form.shipping_fee">
                <template slot="prepend">运费</template>
                <template slot="append">元</template>
              </el-input>
            </el-col>
            <el-col :span="8" class="p-2">
              <el-input placeholder="" v-model="form.shipping_cost">
                <template slot="prepend">成本</template>
                <template slot="append">元</template>
              </el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" class="p-2">
              <el-input placeholder="" v-model="form.weight_ext" style="">
                <template slot="prepend">每增加</template>
                <template slot="append">kg</template>
              </el-input>
            </el-col>
            <el-col :span="8" class="p-2">
              <el-input placeholder="" v-model="form.shipping_ext_fee">
                <template slot="prepend">增加</template>
                <template slot="append">元</template>
              </el-input>
            </el-col>
            <el-col :span="8" class="p-2">
              <el-input placeholder="" v-model="form.shipping_ext_cost">
                <template slot="prepend">成本</template>
                <template slot="append">元</template>
              </el-input>
            </el-col>
          </el-row>
        </div>
      </el-form-item>
      <el-form-item label="退货运费">
        <div>
          <el-row>
            <el-col :span="8" class="p-2">
              <el-input placeholder="" v-model="form.return_weight" style="">
                <template slot="prepend">首重</template>
                <template slot="append">kg</template>
              </el-input>
            </el-col>
            <el-col :span="8" class="p-2">
              <el-input placeholder="" v-model="form.return_shipping_fee">
                <template slot="prepend">运费</template>
                <template slot="append">元</template>
              </el-input>
            </el-col>
            <el-col :span="8" class="p-2">
              <el-input placeholder="" v-model="form.return_shipping_cost">
                <template slot="prepend">成本</template>
                <template slot="append">元</template>
              </el-input>
            </el-col>
          </el-row>
          </div>
        <div>
          <el-row>
            <el-col :span="8" class="p-2">
              <el-input placeholder="" v-model="form.return_weight_ext" style="">
                <template slot="prepend">每增加</template>
                <template slot="append">kg</template>
              </el-input>
            </el-col>
            <el-col :span="8" class="p-2">
              <el-input placeholder="" v-model="form.return_shipping_ext_fee">
                <template slot="prepend">增加</template>
                <template slot="append">元</template>
              </el-input>
            </el-col>
            <el-col :span="8" class="p-2">
              <el-input placeholder="" v-model="form.return_shipping_ext_cost">
                <template slot="prepend">成本</template>
                <template slot="append">元</template>
              </el-input>
            </el-col>
          </el-row>
        </div>
      </el-form-item>
      <el-form-item v-show="form.is_default!=1" label="选择城市" prop="region_ids">
        <el-tree
            @check="bindCheck"
            :data="region"
            show-checkbox
            node-key="id"
            :default-expanded-keys="expandedKeys"
            :default-checked-keys="checkedKeys"
            :props="defaultProps">
        </el-tree>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {addFreightTemplate, getFreightTemplateRegionList, updateFreightTemplate} from "@/api/main/ucenter";

const DEFAULT_FORM = {
  id: 0,

  name: '',
  is_default: 0,

  weight:'',
  shipping_fee: '',
  shipping_cost: '',
  weight_ext: '',
  shipping_ext_fee:'',
  shipping_ext_cost:'',

  return_weight:'',
  return_shipping_fee: '',
  return_shipping_cost: '',
  return_weight_ext: '',
  return_shipping_ext_fee:'',
  return_shipping_ext_cost:'',
  region_ids:[],
}

export default {
  data(){
    return {
      visible: false,
      form: DEFAULT_FORM,
      region: [],
      expandedKeys:[],
      checkedKeys:[],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      rules: {
        name: [
          {required: true, message: '请输入规则名称', trigger: 'burl'},
        ],

        // region_ids: [
        // 	{required: true, message: '请选择城市', trigger: 'burl'},
        // ],
      }
    }
  },
  mounted() {
  },
  methods:{
    getRegionList(){
      getFreightTemplateRegionList({level:2,template_id:this.form.id}).then(res=>{
        if(res.code == 200){
          this.region = res.data

          this.initCheckIds()
        }
      })
    },
    bindCheck(a,b){
      this.form.region_ids = b.checkedKeys
    },
    initCheckIds(){
      let index;
      let region_ids = this.form.region_ids
      let region = this.region
      let checkedKeys = [];
      for (const i in region){
        let check_num = 0;
        const children = region[i].children;
        const len = children.length;
        if (len == 0){
          index = region_ids.findIndex(val => val == region[i].id);
          if (index != -1){
            checkedKeys.push(region[i].id)
          }
        }else {
          for (const j in children){
            index = region_ids.findIndex(val => val == children[j].id);
            if (index != -1){
              check_num ++
              checkedKeys.push(children[j].id)
            }
          }
        }

      }
      this.checkedKeys = checkedKeys

    },
    open(row = DEFAULT_FORM){
      this.$set(this, 'form', row);
      if(row.id > 0){
        this.expandedKeys = [];
        this.form.region_ids = this.form.region_ids ? this.form.region_ids.toString().split(',') : [];
      }
      this.getRegionList();
      this.visible = true;
    },
    close(){
      this.reset()
      this.visible = false;
    },
    reset(){
      this.$set(this, 'form', DEFAULT_FORM);
    },
    save(){
      const model = this.form.id > 0 ? updateFreightTemplate : addFreightTemplate;
      model(this.form).then(res=>{
        if(res.code == 200){
          this.$message.success(res.msg);
          this.reset();
          this.$emit('save');
          this.close();
        }else{
          this.$message.error(res.msg);
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
